<template>
  <div id="tarifs">
    <img :src="optimize(content.img,getWidth())" alt="Tarifs">
  </div>
</template>

<script>
import imgOpti from "@/mixins/imgOpti.js";
export default {
  mixins: [imgOpti],
  props: {
    content: null
  },
  methods: {
    getWidth() {
      return window.innerWidth;
    }
  }
};
</script>

<style lang="scss">
#tarifs {
  width: 100%;
  max-width:800px;
  margin: 1em auto;
}

</style>
